import axios from 'axios'

export default {
    getStatus(token) {
        return axios.get(`/unauthenticated/mcard-requests/${token}`)
    },

    create(token, { npi, name, practice, contact }) {
        return axios.post(`/unauthenticated/mcard-requests/${token}`, { npi, name, practice, contact })
    },
}
